module.exports = __webpack_public_path__ + "img/beian.7431a875.png";